import useMedia from 'use-media';

const points = {
    sm: 480,
    md: 700,
    lg: 1024,
    mobile: 840,
};

export const mediaQuery = () => {
    const isSmall = useMedia(`(max-width: ${points.md - 1}px)`);
    const isMedium = useMedia(`(min-width: ${points.md}px)`);
    const isLarge = useMedia(`(min-width: ${points.lg}px)`);

    const isDesktop = useMedia(`(min-width: ${points.mobile}px)`);
    const isMobile = useMedia(`(max-width: ${points.mobile - 1}px)`);
    const isWide = useMedia(`(max-width: ${points.md - 1}px)`); // use to determine which navigation for carousels

    return { isSmall, isMedium, isLarge, isDesktop, isMobile, isWide };
};